import React from "react";
import { EcpTeacherRetentionRateStudentsSplitview } from "../components/splitviews/ecp-teacher-retention-rate-students-splitview";

export function EcpTeachersPage(props) {
  return <EcpTeacherRetentionRateStudentsSplitview {...props} />;
}
